// 收藏夹
<template>
    <div>
        <van-sticky>
            <van-nav-bar
                title="收藏夹"
                left-text="返回"
                left-arrow
                @click-left="goback"/>
        </van-sticky>
        <ul class="ul-list">
            <li class="ul-li">
                <FavItem
                    v-for="item in data"
                    :key=item.id
                    :data="item" 
                    @delFav="delFav" 
                    @goDetail="goDetail" />
            </li>
        </ul>
    </div>
</template>

<script>
import { 
    NavBar, 
    Card, 
    Tabs, 
    Tab, 
    Icon, 
    Loading, 
    List,
    Sticky
} from 'vant'
import FavItem from '@/view/favorites/components/item'
import { DirectSellFavorites } from '@/api/directsell'
import { toErrorPage } from '@/utils/usePage'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Card.name]: Card,
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [List.name]: List,
        [Sticky.name]: Sticky,
        FavItem
    },
    data() {
        return {
            data: [],
            loading: false,
            finished: false,
            total: 0,
            query: {
                prd_name: null,
                page: 1,
                page_size: 1000
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            var that = this
            that.loading = true
            this.axios.get(DirectSellFavorites, {params: this.query}).then((ret) => {
                that.loading = false
                console.log(ret)
                if(ret.hasOwnProperty("flag")) { 
                    toErrorPage(that,'',ret.info,null)
                } else {
                    that.data = ret.results
                    that.total = ret.count
                }
            })
        },
        goDetail(item) {
            console.log(item)
            this.$router.push(`/nt/directsell/${item.sign_item}`)
        },
        delFav(item) {
            if (item.sign_item) {
                var that = this
                that.loading = true
                this.axios.delete(DirectSellFavorites+ item.version + '/').then((ret) => {
                    that.loading = false
                    if (ret.flag) {
                        that.getData()
                    }
                    
                })
            }
        },
        goback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/home`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .ul-list {
        list-style-type: none;

        .ul-li {
            margin-left: 8px;
            margin-right: 8px;
            margin-top: 0px;
            margin-bottom: 0px;
        }
    }
</style>